(ns ^:no-doc frontend.version)

(defonce version "0.9.13")
